import React, { Component } from 'react';
import { connect } from 'react-redux';
import DatePicker from "react-datepicker";

import { updateFilters } from '../search/actions';
import { MAGIC_NUMBER } from '../../constants/magicNumbers';

const mapStateToProps = state => ({
  search: state.Search
});

export const fixDateTimeMobileIssue = () => {
  const datePickers = document.getElementsByClassName("react-datepicker__input-container");
  Array.from(datePickers).forEach((el => el.childNodes[0].setAttribute("readOnly", true)))
}

class CheckInCheckOutPicker extends Component {
  constructor(props) {
    super(props);

    this.onDateRangeChange = this.onDateRangeChange.bind(this);
  }

  componentDidMount = () => {
    fixDateTimeMobileIssue();
  }

  onDateRangeChange = (range) => {
    const [startDate, endDate] = range;

    const { dispatch } = this.props;
    const { filters } = this.props.search;

    const newFilters = { ...filters };

    if (!!startDate)
      startDate.setHours(12, 0, 0);
    if (!!endDate)
      endDate.setHours(12, 0, 0);

    let from = !!startDate ? new Date(startDate.getTime() - startDate.getTimezoneOffset() * 60000) : undefined;
    let to = !!endDate ? new Date(endDate.getTime() - endDate.getTimezoneOffset() * 60000) : undefined;

    newFilters.dates = { from, to };

    dispatch(updateFilters(newFilters));
  }

  render() {
    const { from, to } = this.props.search.filters.dates;
    return (
      <div>
        <DatePicker
          selectsRange={true}
          dateFormat={MAGIC_NUMBER.CHECK_IN_DATE_FORMAT}
          startDate={from ? new Date(from) : undefined}
          endDate={to ? new Date(to) : undefined}
          onChange={this.onDateRangeChange}
          minDate={new Date()}
          closeOnScroll
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          placeholderText="Select Date Range"
          onChangeRaw={e => e.preventDefault()}
        />
      </div>
    )
  }
}

export default connect(mapStateToProps)(CheckInCheckOutPicker);
